import {useEffect, useState} from "react";

export const useFetchRequest = <TData, TVariables>(
  fetchFunction: (variables: TVariables) => Promise<TData>,
  variables: TVariables
) => {
  const [data, setData] = useState<TData | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    const fetchData = async () => {
      setError(null);

      try {
        const result = await fetchFunction(variables);
        setData(result);
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return {data, isLoading, error};
};
